export default __webpack_public_path__ + "static/media/goshen93.e8715f04.jpg";